import { Component, OnInit } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS, NotificationService } from '@cradua/core';
import { PartyDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-party-container',
  templateUrl: './party-container.component.html',
  styleUrls: ['./party-container.component.scss']
})
export class PartyContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  partys$: Observable<PartyDto[]>;
  loading: boolean;
  isLoading$:  Observable<any>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Party");
    this.partys$ = this.gatwayFacade.loadGateway("Party");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteParty(deletedValue: any) {
    this.gatwayFacade.remove("Party", deletedValue);
    // this.store.dispatch(PartyStoreActions.removeParty({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitParty(formValue: any) {
    // formValue.Partys = formValue.Partys.reverse();
    const pullData = formValue.Parties;
    //const newPullData = formValue.Partyes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllParty = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllParty.push(pullData[i]);
    }
  }

// check if the addAllParty array is not empty, then dispatch the data to the store
   if(addAllParty.length !== 0) {
    this.gatwayFacade.add('Party', addAllParty);
    // this.store.dispatch(PartyStoreActions.addParty({newParty: addAllParty}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Party', allUpdates, ['id']);
    // this.store.dispatch(PartyStoreActions.updateParty({updateParty: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }


}
